import request from '@/utils/request'

const userMessage = {
  name: 'userMessage',
  state: {
    isUserMessageDetailLoading: false,
    userMessageDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USERMESSAGE_DETAIL_LOADING: (state, data) => {
      state.isUserMessageDetailLoading = data
    },
    SET_MODULES_USERMESSAGE_DETAIL_DATA: (state, data) => {
      state.userMessageDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserMessageDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USERMESSAGE_DETAIL_LOADING', true)
      commit('SET_MODULES_USERMESSAGE_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userMessage/userMessageDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USERMESSAGE_DETAIL_LOADING', false)
          commit('SET_MODULES_USERMESSAGE_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USERMESSAGE_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserMessageDetailData({ commit }) {
      commit('SET_MODULES_USERMESSAGE_DETAIL_DATA', {})
    }
  }
}

export default userMessage
